export class AccountManagerConsts
{
    public static readonly WATCHLISTS_TREE_NAME = 'watchListTree'
    public static readonly WATCHLISTS_TREE = '#' + AccountManagerConsts.WATCHLISTS_TREE_NAME;
    public static readonly WATCHLISTS_TREE_REFRESH_NAME = AccountManagerConsts.WATCHLISTS_TREE_NAME + 'Refresh';
    public static readonly WATCHLISTS_TREE_REFRESH = '#' + AccountManagerConsts.WATCHLISTS_TREE_REFRESH_NAME;
}
